import React, { Fragment, useContext } from 'react';
import context from '../context';
import styled from 'styled-components';
import { Container, Row, Col } from 'react-bootstrap';
import Link from "../components/link";
import {
  WhatsAppOutlined,
  EnvironmentOutlined,
  FacebookOutlined,
  InstagramOutlined,
  UpOutlined,
  MailOutlined
} from '@ant-design/icons';

import Logo from './logo-footer';
import { NavLink } from '../styled-components';

const Footer = styled.footer`
  padding: 2.5rem 0 0;
  background-color: #000;
`;

const Tagline = styled.p`
  color: #fff;
  font-size: 0.95rem;
  margin-top: 1.2rem;
  max-width: 260px;
  line-height: 1.4;
  text-align: center;

`;

const InfoList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const InfoItem = styled.li`
  color: #fff;
  font-size: 0.95rem;
  margin-bottom: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.45rem;      /* separación icono–texto */
  flex-wrap: wrap;
`;

const InfoLink = styled.a`
  color: #fff !important;
  &:hover {
    text-decoration: underline !important;
  }
`;

const NavCont = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  @media (min-width: 768px) {
    align-items: flex-start;
    text-align: left;
  }
`;

const NavList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const NavItem = styled.li`
  font-size: 0.95rem;
  margin-bottom: 0.4rem;

  &::before {
    content: "‣";
    color: #fff;
    margin-right: 0.3rem;
  }
`;

const NavLinkCustom = styled(NavLink)`
  margin-left: 0.3rem;
  color: #fff;

  &:hover {
    font-weight: bold;
  }
`;

const SocialCont = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1rem 0 1.3rem;
  flex-wrap: wrap;

  @media (min-width: 768px) {
    justify-content: flex-start;
  }
`;

const SocialItem = styled.span`
  color: #fff;
  font-size: 0.9rem;
  margin-right: 0.4rem;
`;

const SocialLink = styled.a`
  color: #fff;
  margin-left: 0.5rem;

  &:hover {
    color: ${props => props.theme.primaryColor};
  }
`;

const BackTop = styled.button`
  display: flex;
  justify-content: center;
  border: none;
  cursor: pointer;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: ${props => props.theme.primaryColor};
  margin-bottom: 1rem;
  transition: 250ms ease;
  color: #fff;
  box-shadow:
    0px 1px 1px rgba(0, 0, 0, 0.12),
    0px 2px 2px rgba(0, 0, 0, 0.12),
    0px 4px 4px rgba(0, 0, 0, 0.12),
    0px 8px 8px rgba(0, 0, 0, 0.12);

  &:hover {
    filter: brightness(1.1);
  }

  &:active {
    box-shadow: none;
  }
`;

const CopyrightCont = styled.div`
  padding: 0.35rem 0;
  color: #fff;
  background-color: ${props => props.theme.primaryColor};
  font-size: 0.8rem;
`;

const CopyrightInnerCont = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  text-align: center;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    text-align: left;
  }
`;

const DevelopedBy = styled.a`
  color: #fff !important;
  transition: 250ms ease;
  font-weight: bold;

  &:hover {
    text-decoration: underline !important;
  }
`;

export default () => {
  const state = useContext(context);

  // Dirección con fallback
  const address = state.address || "Nueva Tajamar 481, Las Condes";

  return (
    <Fragment>
      <Footer>
        <Container>
          <Row>
            {/* LOGO + FRASE */}
            <Col xs={12} md={4} className="text-start mb-4">
              <Link to="/">
                <Logo dark />
              </Link>
              <Tagline>
                Tú socio estratégico en la construcción de tu patrimonio.
              </Tagline>
            </Col>

            {/* NAVEGACIÓN */}
            <Col xs={12} md={4} className="mb-4 d-flex justify-content-center justify-content-md-start">
              <NavCont>
               
                <NavList>
                   <br></br>
                    <br></br>
                     <br></br>
                     
                  <NavItem>
                    <Link to="/about">
                      <NavLinkCustom light>NOSOTROS</NavLinkCustom>
                    </Link>
                  </NavItem>
                  <NavItem>
                    <Link to="/properties">
                      <NavLinkCustom light>GESTIÓN INMOBILIARIA</NavLinkCustom>
                    </Link>
                  </NavItem>
                  <NavItem>
                    <Link to="/temporalrent">
                      <NavLinkCustom light>ARRIENDOS POR NOCHE</NavLinkCustom>
                    </Link>
                  </NavItem>
                  <NavItem>
                    <Link to="/how-much">
                      <NavLinkCustom light>ASESORÍA FINANCIERA</NavLinkCustom>
                    </Link>
                  </NavItem>
                </NavList>
              </NavCont>
            </Col>

            {/* CONTACTO + REDES */}
            <Col xs={12} md={4} className="mb-4 text-center text-md-start">
              <NavCont>
                <BackTop onClick={() => window.scrollTo(0, 0)}>
                  <UpOutlined />
                </BackTop>

                <SocialCont>
                  <SocialItem>Síguenos en:</SocialItem>
                  <SocialLink href={state.facebook} target="_blank" rel="noopener">
                    <FacebookOutlined />
                  </SocialLink>
                  <SocialLink href={state.instagram} target="_blank" rel="noopener">
                    <InstagramOutlined />
                  </SocialLink>
                </SocialCont>

                <InfoList>
                 

                  <InfoItem>
                    <WhatsAppOutlined />
                    <InfoLink
                      title="Enviar WhatsApp"
                      href={`https://api.whatsapp.com/send?phone=${state.movil.replace(/\s/g, '')}&text=Hola,%20estoy%20visitando%20su%20sitio%20Web%20y%20quisiera%20comunicarme%20con%20ustedes.`}
                      target="_blank"
                      rel="noopener"
                    >
                      {state.movil}
                    </InfoLink>
                  </InfoItem>

                  <InfoItem>
                    <WhatsAppOutlined />
                    <InfoLink
                      title="Enviar WhatsApp"
                      href={`https://api.whatsapp.com/send?phone=${state.phone.replace(/\s/g, '')}&text=Hola,%20estoy%20visitando%20su%20sitio%20Web%20y%20quisiera%20comunicarme%20con%20ustedes.`}
                      target="_blank"
                      rel="noopener"
                    >
                      {state.phone}
                    </InfoLink>
                  </InfoItem>

                  <InfoItem>
                    <MailOutlined />
                    <InfoLink
                      title="Enviar Email"
                      href="mailto:contacto@galacticaschile.com"
                      target="_blank"
                      rel="noopener"
                    >
                      contacto@galacticaschile.com
                    </InfoLink>
                  </InfoItem>
                   <InfoItem>
                    <EnvironmentOutlined />
                    <span>{address}</span>
                  </InfoItem>
                </InfoList>
              </NavCont>
            </Col>
          </Row>
        </Container>
      </Footer>

      <CopyrightCont>
        <Container>
          <CopyrightInnerCont>
            <span>{new Date().getFullYear()} © Todos los derechos reservados</span>
            <div>
              Desarrollado por{" "}
              <DevelopedBy
                href="https://www.nexxoschile.cl"
                target="_blank"
                rel="noopener"
              >
                Nexxos Chile
              </DevelopedBy>
            </div>
          </CopyrightInnerCont>
        </Container>
      </CopyrightCont>
    </Fragment>
  );
};